import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { IProcurementParameterAuditApi } from './base';
import {
  GetAuditByClaimRequest,
  GetAuditRequest
} from '../models/request';
import {
  GetAuditByClaimResponse,
  GetAuditResponse
} from '../models/response';

const baseRoute: string = 'ProcurementParameterAudit';

export class ProcurementParameterAuditApi extends IProcurementParameterAuditApi {
  getParameterAudit(
    request: GetAuditRequest
  ): Promise<AxiosResponse<Result<GetAuditResponse[]>>> {
    return api.get(`${baseRoute}/getbyprocurement`, { params: request });
  }
}

